var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 79.999,
  height: 80,
  viewBox: "0 0 79.999 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "india",
  transform: "translate(0 -0.001)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_309",
  "data-name": "Ellipse 309",
  cx: 39.5,
  cy: 40,
  rx: 39.5,
  ry: 40,
  transform: "translate(0.501 0.001)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_356",
  "data-name": "Path 356",
  d: "M339.191,157.873H314.218a112.064,112.064,0,0,1,.021,26.868h25.005a40.569,40.569,0,0,0-.053-26.868Z",
  transform: "translate(-261.507 -131.385)",
  fill: "#efecec"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_357",
  "data-name": "Path 357",
  d: "M267.708,27.824h24.973a.281.281,0,0,0-.013-.035A40.557,40.557,0,0,0,258.105.972C264.31,4.373,266.122,15.148,267.708,27.824Z",
  transform: "translate(-214.998 -0.805)",
  fill: "#e97e24"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_358",
  "data-name": "Path 358",
  d: "M258.113,341.878a40.558,40.558,0,0,0,34.59-26.9c.013-.039.025-.078.039-.115H267.736C266.163,327.613,264.343,338.463,258.113,341.878Z",
  transform: "translate(-215.004 -262.045)",
  fill: "#258f44"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_359",
  "data-name": "Path 359",
  d: "M0,171.387A40.473,40.473,0,0,0,2.262,184.74H55.882a112.073,112.073,0,0,0-.02-26.868H2.316A40.449,40.449,0,0,0,0,171.387Z",
  transform: "translate(0 -131.384)",
  fill: "#efefef"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_360",
  "data-name": "Path 360",
  d: "M13.546,26.984c0,.011-.008.022-.013.035H67.079C65.492,14.343,61.593,3.568,55.389.167,54.189.061,52.976,0,51.748,0A40.539,40.539,0,0,0,13.546,26.984Z",
  transform: "translate(-11.217 0)",
  fill: "#ea8634"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_361",
  "data-name": "Path 361",
  d: "M66.838,314.867H13.219c.014.038.026.076.039.115a40.543,40.543,0,0,0,38.23,27.063c1.228,0,2.441-.06,3.641-.168C61.359,338.462,65.265,327.612,66.838,314.867Z",
  transform: "translate(-10.957 -262.045)",
  fill: "#359846"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_5358",
  "data-name": "Group 5358",
  transform: "translate(-300 -299)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_344",
  "data-name": "Ellipse 344",
  transform: "translate(328 327)",
  fill: "none",
  stroke: "#0058d6",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5354",
  "data-name": "Group 5354"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_1",
  "data-name": "Line 1",
  y2: 21,
  transform: "translate(340.5 328.5)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2",
  "data-name": "Line 2",
  y2: 21,
  transform: "translate(351 339) rotate(90)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5355",
  "data-name": "Group 5355",
  transform: "translate(339.439 -141.479) rotate(45)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_1-2",
  "data-name": "Line 1",
  y2: 21,
  transform: "translate(340.5 328.5)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2-2",
  "data-name": "Line 2",
  y2: 21,
  transform: "translate(351 339) rotate(90)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5356",
  "data-name": "Group 5356",
  transform: "translate(519.507 -106.89) rotate(67)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_1-3",
  "data-name": "Line 1",
  y2: 21,
  transform: "translate(340.5 328.5)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2-3",
  "data-name": "Line 2",
  y2: 21,
  transform: "translate(351 339) rotate(90)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5357",
  "data-name": "Group 5357",
  transform: "matrix(-0.391, 0.921, -0.921, -0.391, 785.595, 158.026)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_1-4",
  "data-name": "Line 1",
  y2: 21,
  transform: "translate(340.5 328.5)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2-4",
  "data-name": "Line 2",
  y2: 21,
  transform: "translate(351 339) rotate(90)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
})))));
export default __webpack_public_path__ + "static/media/indianFlag.611bea4d.svg";
export { SvgComponent as ReactComponent };